import * as signalR from "@microsoft/signalr";
import { getFromStorage, saveToStorage } from "utils/storage";
import { refreshToken } from "hooks/api/authService";

const API_URL = process.env.REACT_APP_API_URL || "";
// The SignalR hub is served from its own path, not the REST API path.
const HUB_BASE_URL = API_URL.replace(/\/api\/v\d+\/?$/, "");

export const NOTIFICATION_HUB_URL = `${HUB_BASE_URL}/hubs/notifications`;
export const NEW_NOTIFICATION_METHOD = "ReceiveNotification";

function isTokenExpired(token) {
  try {
    const payload = JSON.parse(atob(token.split(".")[1]));
    return !payload?.exp || Date.now() >= payload.exp * 1000;
  } catch (error) {
    return true;
  }
}

// SignalR calls this before the initial connect and before every
// automatic-reconnect attempt, so refreshing here mirrors what
// newAxiosInterceptor.js does on a 401 for regular API calls.
async function getAuthToken() {
  let token =
    getFromStorage("user_data")?.access_token || getFromStorage("user_token");

  if (!token || isTokenExpired(token)) {
    try {
      const newUserData = await refreshToken();
      saveToStorage("user_data", newUserData);
      token = newUserData?.access_token;
    } catch (error) {
      // eslint-disable-next-line no-console
      console.error("Notification hub token refresh failed:", error);
    }
  }

  return token;
}

let connection = null;

export function getNotificationHubConnection() {
  if (!connection) {
    connection = new signalR.HubConnectionBuilder()
      .withUrl(NOTIFICATION_HUB_URL, {
        accessTokenFactory: getAuthToken,
      })
      .withAutomaticReconnect()
      .build();
  }
  return connection;
}

export function startNotificationHubConnection() {
  const hub = getNotificationHubConnection();
  if (hub.state === signalR.HubConnectionState.Disconnected) {
    return hub.start().catch((error) => {
      // eslint-disable-next-line no-console
      console.error("Notification hub connection failed:", error);
    });
  }
  return Promise.resolve();
}
